var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"height-full"},[(['AssessmentStartPage', 'AssessmentStartListPage', 'ChooseMainSymptomPage', 'SymptomsQuestionsPage', 'AssessmentSymptomsPriorityListPage'].indexOf(_vm.$route.name) > -1)?_c('div',{staticClass:"width-full height-full"},[_c('info-icon-svg')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36a03b92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/shared/AssessmentAlerts.vue
// module id = null
// module chunks = 